import { render, staticRenderFns } from "./browseAccount.vue?vue&type=template&id=88bd4efc&scoped=true&"
import script from "./browseAccount.vue?vue&type=script&lang=js&"
export * from "./browseAccount.vue?vue&type=script&lang=js&"
import style0 from "./browseAccount.vue?vue&type=style&index=0&id=88bd4efc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88bd4efc",
  null
  
)

export default component.exports